import { render } from "./ItemBadge.vue?vue&type=template&id=dece1408&scoped=true"
import script from "./ItemBadge.vue?vue&type=script&lang=js"
export * from "./ItemBadge.vue?vue&type=script&lang=js"

import "./ItemBadge.vue?vue&type=style&index=0&id=dece1408&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dece1408"]])

export default __exports__